// src/components/RegionSelect.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/useAppStore';
import { PublicAPI } from '../api/public';

const Select = styled.select`
  height: 42px; padding: 0 12px; border-radius: 12px;
  background: var(--card); color: inherit; border: 1px solid var(--bdr);
  box-shadow: var(--shadow);
  @media (max-width: 420px){
    height: 34px;
    padding: 0 8px;
    border-radius: 9px;
    font-size: 12.5px;
  }
`;

export default function RegionSelect({ includeAllOption = true }){
  const { t, i18n } = useTranslation();
  const regionId = useAppStore(s => s.regionId);
  const setRegion = useAppStore(s => s.setRegion);
  const [regions, setRegions] = React.useState([]);

  React.useEffect(()=>{
    let cancelled = false;
    (async ()=>{
      try{
        const res = await PublicAPI.regions({ locale: i18n.language || 'ru' });
        const list = Array.isArray(res?.regions) ? res.regions : [];
        if (!cancelled) setRegions(list);
      }catch{ if(!cancelled) setRegions([]); }
    })();
    return ()=>{ cancelled = true; };
  }, [i18n.language]);

  // Если регион ещё не выбран — по умолчанию выбираем первый из списка
  React.useEffect(()=>{
    if ((regionId === '' || regionId == null) && regions.length > 0) {
      const r = regions[0];
      const name = getRegionName(r);
      const slug = r?.slug || '';
      const code = r?.code || '';
      setRegion(r.id, name, slug, code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions, regionId]);

  // Функция для получения названия региона в зависимости от языка
  const getRegionName = (region) => {
    if (!region) return '';
    const lang = i18n.language || 'ru';
    
    if (lang === 'zh' || lang === 'zh-CN') {
      return region.name_zh || region.name_en || region.name_ru || region.name || region.slug;
    } else if (lang === 'en') {
      return region.name_en || region.name_ru || region.name || region.slug;
    } else {
      return region.name_ru || region.name || region.slug;
    }
  };

  const onChange = (e)=>{
    const id = e.target.value ? Number(e.target.value) : '';
    const r = regions.find(x => String(x.id) === String(id));
    const name = getRegionName(r);
    const slug = r?.slug || '';
    const code = r?.code || '';
    setRegion(id, name, slug, code);
  };

  return (
    <Select value={regionId || ''} onChange={onChange} aria-label={t('districts')}>
      {includeAllOption && (
        <option value="">{t('regions.allRegions')}</option>
      )}
      {regions.map((r)=>{
        const name = getRegionName(r);
        return <option key={r.id} value={r.id}>{name}</option>;
      })}
    </Select>
  );
}
